const isLocalHost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

const isLocalNetworkHost =
  typeof window !== 'undefined' &&
  /^(10|172\.(1[6-9]|2\d|3[0-1])|192\.168)\./.test(window.location.hostname);

const isReactDevServer =
  typeof window !== 'undefined' &&
  window.location.port === '3000';

const localBackendUrl =
  typeof window !== 'undefined'
    ? `http://${window.location.hostname === 'localhost' ? '127.0.0.1' : window.location.hostname}:5050`
    : '';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || ((isLocalHost || isLocalNetworkHost || isReactDevServer) ? localBackendUrl : '');

export default API_BASE_URL;
